<template>
  <main-content with_go_back_bar>
    <div
      class="contract-button_wrapper d-flex w-100 flex-column flex-sm-row justify-content-between align-items-start my-3 sm:m-3 p-2 sm:p-4">
      <div class=" p-3 mb-3 mb-sm-0">
        <div class="mb-3" v-if="contract_data && contract_data.status === contractStatus.PENDING">
          <router-link :to="{ name: 'signing_guid' }" class="btn btn-warning w-100">
            {{ $t('online_contract.label.signing_tutorial') }}
          </router-link>
        </div>
        <a href="https://www.pki.co.ir/page2608" class=" btn btn-success w-100" target="_blank">
          {{ $t('online_contract.label.download_digital_signature_app') }}
        </a>
      </div>
      <div class="d-flex flex-column align-items-center align-items-sm-start w-auto p-3">
        <div v-if="shouldPayForContract" class="w-100 sm:w-auto">
          <button @click="redirectForPayment" class="btn btn-primary w-100 sm:w-auto">
            {{ $t('online_contract.label.pay') }} : {{ contract_data.price }} (ریال)
          </button>
        </div>
        <div v-else-if="contract_data && contract_data.status === contractStatus.PENDING" class="w-100 sm:w-auto">
          <div v-if="!isg_url">
            <button v-if="contract_data.sign_type === signType.DIGITAL" @click="createSignRequest"
              class="btn btn-success w-100 sm:w-auto" :class="{ 'disabled': loading }" :disabled="loading">
              {{ $t('online_contract.label.create_sign_request') }}
              <span v-if="loading" class="spinner-border spinner-border-sm mr-2"></span>
            </button>

            <button v-else-if="contract_data.sign_type === signType.SMS" @click="requestSendSmsn"
              class="btn btn-success w-100 sm:w-auto" :class="{ 'disabled': loading }" :disabled="loading">
              {{ $t('online_contract.label.create_sign_request') }}
              <span v-if="loading" class="spinner-border spinner-border-sm mr-2"></span>
            </button>
          </div>
          <div v-if="isg_url">
            <qrcode-vue :value="isg_url" :size="100" level="M" />
            <div>
              <p>
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                  fill="#F19E39">
                  <path
                    d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
                </svg>
                <span class="text-white-in-dark-mode">قرارداد آماده امضا است.</span>
              </p>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <label class="">
            <span>{{ $t('online_contract.columns.payment_status') }} : </span>
            <span v-text="getPaymentStatusText(contract_data.payment_status)"
              :class="['p-2', 'badge', 'badge-' + getPaymentStatusStyle(contract_data.payment_status)]"></span>
          </label>
        </div>
      </div>
    </div>
    <div v-if="contract_data">
      <div style="border: 3px solid #999;" class="p-4">
        <div v-html="contract_data.contract_content" style="overflow:scroll "></div>
      </div>
    </div>

    <div id="myModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content bg-white">
          <form @submit.prevent="verify">
            <div class="modal-header">
              <h5 class="modal-title" id="myModalLabel">{{ $t('online_contract.label.verification_contract') }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <label for="code">{{ $t('online_contract.label.otp_code') }}</label>
              <input type="text" v-model="code" id="code" name="code" class="form-control">
            </div>
            <div class="modal-footer">
              <button type="button" @click="$('#myModal').close()" class="btn btn-secondary" data-dismiss="modal">{{
                $t('btn.close') }}</button>
              <button type="submit" class="btn btn-primary" :class="{ 'disabled': loading }" :disabled="loading">
                {{ $t('btn.submit') }}
                <span v-if="loading" class="spinner-border spinner-border-sm mr-2"></span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main-content>
</template>

<script>
import { ApiUrl, onlineContractService } from '@/common/api.service';
import { BASE_PATH } from '@/common/config';
import mainContent from "@/components/main-content";
import {
  contractPaymentStatusVariant,
  contractStatus,
  paymentStatus,
  paymentStatusStr
} from '@/constants/onlineContract';
import axios from "axios";
import $ from 'jquery';
import QrcodeVue from "qrcode.vue";
import toastr from "toastr";
import { signType, signTypeStr } from '@/constants/onlineContractSignType';

export default {
  components: {
    "main-content": mainContent,
    QrcodeVue,
  },
  props: {
    submitSingleRequest: {
      default: function ($event, query) { },
      type: Function,
    },
  },
  data() {
    return {
      hashid: this.$route.params.hashid,
      payment_id: this.$route.query.payment_id,
      contract_data: null,
      isg_url: '',
      loading: false,
      code: null,
    };
  },
  computed: {
    contractStatus() {
      return contractStatus
    },
    paymentStatus() {
      return paymentStatus
    },
    signType() {
        return signType;
    },
    signTypeStr() {
        return signTypeStr;
    },
    shouldPayForContract() {
      if (this.contract_data) {
        return (this.contract_data.payment_status === paymentStatus.UNPAID
          && this.contract_data.status === contractStatus.PENDING)
          ;
      }
      return false
    },
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false,
      };
      return toastr;
    },
  },
  methods: {
    getContractContent(e) {
      axios({
        url: ApiUrl.path(`online-contract/user-contract/${this.hashid}`),
        method: "GET",
      })
        .then((response) => {
          this.contract_data = response.data.data;
        })
        .catch(({ response }) => {
          this.toastr.error(response.data.message);
        });
    },
    redirectForPayment() {
      onlineContractService.createPayment(this.hashid)
        .then(response => {
          let tracking_code = response.data.data.tracking_code;
          window.location = BASE_PATH + '/online-contract/payment/pay/' + tracking_code;
        }).catch(({ response }) => {
          this.toastr.error(response.data.message);
        })
    },
    checkForPaymentIdAndShowMessage() {
      if (this.payment_id) {
        onlineContractService.inquiryPayment(this.payment_id)
          .then(response => {
            this.toastr.success(response.data.message);
          })
          .catch(({ response }) => {
            this.toastr.error(response.data.message);
          }
          )
          .finally(() => {
            this.$router.replace({
              path: this.$route.path,
              query: {}
            });
          })
      }
    },
    createSignRequest() {
      this.loading = true
      onlineContractService.crateSignRequest(this.hashid)
        .then(response => {
          this.isg_url = response.data.data.gateway_url;
          this.toastr.success(response.data.data.message);
        })
        .catch(({ response }) => {
          this.toastr.error(response.data.message);
        }).finally(() => {
          this.loading = false
        })
    },
    requestSendSmsn() {
      this.loading = true
      onlineContractService.requestSendSms(this.hashid)
        .then(response => {
          this.toastr.success(response.data.message)
          $('#myModal').modal({
            backdrop: 'static',
            keyboard: false
          });
        })
        .catch(({ response }) => {
          this.toastr.error(response.data.message);
        }).finally(() => {
          this.loading = false
        })
    },
    getPaymentStatusText(status) {
      return paymentStatusStr.get(status)
    },
    getPaymentStatusStyle(status) {
      return contractPaymentStatusVariant(status)
    },
    verify(e) {
      let form = $(e.target)

      form.validate({
        lang: "fa",
        rules: {
          code: {
            required: true,
          },
        },
      });

      if (!form.valid()) {
        return
      }
      let params = {
        code: this.code
      }

      this.loading = true;
      onlineContractService.verifyContract(this.hashid, params)
        .then((response) => {
          $('#myModal').modal('hide');
          this.toastr.success(response.data.message);
          this.getContractContent();
        }).catch(({ response }) => {
          this.toastr.error(response.data.message);
        }).finally(() => {
          this.loading = false
        })

    }
  },
  mounted() {
    this.checkForPaymentIdAndShowMessage()
    this.getContractContent();
  },
};
</script>
<style scoped>
.preview_img {
  max-width: 70px;
  max-height: 70px;
  position: absolute;
  top: 10px;
  left: 80px;
}

.c_pointer {
  cursor: pointer;
}

ul,
li {
  list-style: none;
  padding: 0;
}

.containers {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
  background: linear-gradient(45deg, #209cff, #68e0cf);
  padding: 3rem 0;
}

.wrapper {
  background: #eaf6ff;
  padding: 2rem;
  border-radius: 15px;
}

h1 {
  font-size: 1.1rem;
  font-family: sans-serif;
}

.sessions {
  margin-top: 2rem;
  border-radius: 12px;
  position: relative;
}

li {
  padding-bottom: 1.5rem;
  border-right: 1px solid #abaaed;
  position: relative;
  padding-right: 20px;
  margin-right: 10px;
  /* margin-top: -1.5rem; */
}

li:first-child {
  padding-bottom: 1.5rem;
  border-right: 1px solid #abaaed;
  position: relative;
  padding-right: 20px;
  margin-right: 10px;
  margin-top: -2rem;
}

.timeShow {
  padding-bottom: 1.5rem;
  border-right: 1px solid #abaaed;
  position: relative;
  padding-right: 20px;
  margin-right: 10px;
  margin-bottom: -1.5rem;
}

.timeShow::after {
  content: "";
  width: 15px;
  height: 15px;
  background: white;
  border: 1px solid #4e5ed3;
  box-shadow: 3px 3px 0px #bab5f8;
  box-shadow: 3px 3px 0px #bab5f8;
  border-radius: 50%;
  position: absolute;
  right: -8px;
  top: 0px;
}

.text-timeShow {
  font-size: 12px;
  font-weight: 400;
}

li:last-child {
  border: 0px;
  padding-bottom: 0;
}

li::after {
  content: "";
  width: 15px;
  height: 15px;
  background: white;
  border: 1px solid #4e5ed3;
  box-shadow: 3px 3px 0px #bab5f8;
  box-shadow: 3px 3px 0px #bab5f8;
  border-radius: 50%;
  position: absolute;
  right: -8px;
  top: 0px;
}

.time {
  color: #2a2839;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
}

p {
  color: #4f4f4f;
  font-family: sans-serif;
  line-height: 1.5;
  margin-top: 0.4rem;
}

.btn .badge {
  margin: 0 1rem 0 0;
}

.create-services {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-end;
}

@media screen and (max-width: 1000px) {
  .marginTopSm {
    margin: 1rem 0 0 0;
  }

  .factorPersonalInfo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  tr td {
    font-size: 10px;
  }

  table thead {
    font-size: 9px;
  }
}


@media screen and (max-width: 540px) {
  .contract-button_wrapper>div {
    border: 3px solid #999;
    width: 100% !important;
  }
}

@media screen and (min-width: 540px) {
  .contract-button_wrapper {
    border: 3px solid #999;
  }
}
</style>
